(() => {
  function updateCollectionBackground() {
    const backgrounds = window.collectionFilterBackgrounds || {};
    const params = new URLSearchParams(window.location.search);

    const selectedValues = [...params.entries()]
      .filter(([key]) => key.startsWith('filter.'))
      .map(([, value]) => value);

    const matchedValue = selectedValues.find(
      (value) => backgrounds[value]
    );

    const target = document.querySelector('#MainContent');
    if (!target) return;

    if (matchedValue) {
      target.style.setProperty(
        'background-image',
        `url("${backgrounds[matchedValue]}")`,
        'important'
      );
      target.style.setProperty('background-size', 'cover');
      target.style.setProperty('background-position', 'center top');
      target.style.setProperty('background-repeat', 'no-repeat');
    } else {
      target.style.removeProperty('background-image');
      target.style.removeProperty('background-size');
      target.style.removeProperty('background-position');
      target.style.removeProperty('background-repeat');
    }
  }

  updateCollectionBackground();

  window.addEventListener('popstate', updateCollectionBackground);

  new MutationObserver(updateCollectionBackground).observe(document.body, {
    childList: true,
    subtree: true
  });
})();